import mutationsTypes from '@/store/mutationTypes'

const Mutations = {
  [mutationsTypes.OFTEN_USE_SET_LIST]: (state, payload) => {
    state.oftenUseList = payload.oftenUseList
  }
}

export default Mutations
